import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { CheckIcon } from 'lucide-react';
import ApplyButton from './ApplyButton';
interface WhoThisIsForSectionProps {
  scrollToCalendar?: () => void;
}
const WhoThisIsForSection = ({
  scrollToCalendar
}: WhoThisIsForSectionProps) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const specialties = ['Chiropractors', 'Dentists', 'Physical Therapists', 'Med Spas & Aesthetics Clinics', 'Mental Health & Behavioral Health Practices', 'Primary Care & Family Medicine', 'Provider-Owned Clinics'];
  return <section className="w-full bg-white py-12 sm:py-20 px-3 sm:px-4" data-id="element-384">
      <div className="max-w-3xl mx-auto" data-id="element-385">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="text-center mb-8 sm:mb-12" data-id="element-386">
          <h2 className="text-gray-900 text-2xl sm:text-3xl md:text-4xl mb-3 sm:mb-4 typekit-heading" data-id="element-387">
            Who This Is For
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="bg-gradient-to-b from-gray-50 to-white border border-gray-200 rounded-lg p-6 sm:p-10 shadow-sm" data-id="element-388">
          <div className="space-y-4 sm:space-y-5" data-id="element-389">
            {specialties.map((specialty, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={inView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.5,
            delay: 0.3 + 0.08 * index
          }} className="flex items-center" data-id="element-390">
                <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-[#ffdf07] flex items-center justify-center mr-4 sm:mr-5 flex-shrink-0" data-id="element-391">
                  <CheckIcon size={18} className="text-black sm:w-5 sm:h-5" data-id="element-392" />
                </div>
                <p className="text-gray-900 libre-caslon-text-regular text-base sm:text-xl" data-id="element-393">
                  {specialty}
                </p>
              </motion.div>)}
          </div>
        </motion.div>

        <div className="mt-10 sm:mt-12" data-id="element-394">
          {scrollToCalendar ? <div className="flex justify-center" data-id="element-395">
              <div className="relative" data-id="element-396">
                <div className="button-border-light" data-id="element-397"></div>
                <motion.button onClick={scrollToCalendar} whileHover={{
              scale: 1.05,
              boxShadow: '0px 8px 20px rgba(255, 223, 7, 0.3)'
            }} className="relative z-10 bg-gradient-to-r from-[#ffdf07] via-[#fae651] to-[#ffdf07] text-black font-semibold py-3 sm:py-4 px-8 sm:px-12 rounded-md text-base sm:text-lg shadow-[0_4px_14px_rgba(255,223,7,0.25)] border border-[#ffd70077] transition-all duration-300" data-id="element-398">
                  Book My Strategy Call
                </motion.button>
              </div>
            </div> : <ApplyButton data-id="element-399" />}
        </div>
      </div>
    </section>;
};
export default WhoThisIsForSection;